import React from 'react';
import { SignUpForm } from '../../../../modules/LoginRouter/components/SignUpForm/SignUpForm';
import styles from './SignupXray.module.css';
import { trackWebAppGAEvent } from '../../../../common/helpers/plugins/website-google-analytics';
import { CustomerQualificationLayout } from '../../../../modules/LoginRouter/components/CustomerQualificationFlow/CustomerQualificationFlow';
import { useLocation } from 'react-router-dom';

export const SignupXray = ({
  onClose,
  website,
  email,
  firstName,
  lastName,
  companyName,
}: {
  onClose?: () => void;
  website: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  companyName?: string;
}) => {
  const location = useLocation<{ website?: string }>();
  const { website: websiteUrl } = location.state || {};
  const version = localStorage.getItem('onboardingReportVersion');
  const onSubmitSuccess = () => {
    trackWebAppGAEvent('click', {
      category: 'login',
      label: `x-ray-onboarding-signup-success-${version}`,
    });
    onClose?.();
  };
  return (
    <CustomerQualificationLayout step={1}>
      <div className={styles.container}>
        <SignUpForm
          hideTrial
          showFacebook={false}
          withPasswordConfirmation={false}
          onSubmitSuccess={onSubmitSuccess}
          withCompanyName
          withPhone
          forXrayOnboarding
          websiteURL={website || websiteUrl}
          email={email}
          firstName={firstName}
          lastName={lastName}
          companyName={companyName}
          withWebsite
          heading=""
          signUpButtonName="Next Step"
          css={{
            form: styles.form,
            heading: styles.heading,
            submitBtn: styles.submitBtn,
            helpText: styles.helpText,
          }}
        />
      </div>
    </CustomerQualificationLayout>
  );
};
